module.exports = __webpack_public_path__ + "00365f524caf04c7fa15c3aaa76d447d.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Regular.eot
// module id = 398
// module chunks = 0